import mediaListSaga from 'modules/Media/saga/list';
import mediaDetailsSaga from 'modules/Media/saga/details';
import { SagaIterator } from 'redux-saga';
import { fork } from 'redux-saga/effects';

export default function* mediaSaga(): SagaIterator {
  yield fork(mediaListSaga);
  yield fork(mediaDetailsSaga);
}
